<template>
  <ModalBackdrop :duration="duration">
    <div
      class="modal-wraper fixed flex inset-0 z-20 overflow-y-auto"
      tabindex="0"
      @keydown.esc="hideFunction"
      data-test="modal"
      @click.self="clickOutsideFunction"
    >
      <div @click.self="clickOutsideFunction" class="p-3 h-full w-full flex items-center content-center m-auto">
        <GrowTransition>
          <div
            class="
              modal
              shadow-xl
              md:w-auto
              fillAvailable
              overflow-y-auto
              rounded-lg
              pt-3
              m-auto
              flex flex-col
              relative
            "
          >
            <button
              v-if="closeBtnIsVisible"
              type="button"
              aria-label="Close"
              data-test="modal-close-btn"
              class="close ml-auto mb-3 mr-3"
              @click="hideFunction($event)"
            >
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="transition opacity-70 hover:opacity-100"
              >
                <path
                  d="M13.3927 3.27643L9.06141 7.99976L13.3927 12.7231C13.622 12.9733 13.7508 13.3126 13.7508 13.6664C13.7508 14.0202 13.622 14.3596 13.3927 14.6098C13.1633 14.86 12.8523 15.0005 12.5279 15.0005C12.2036 15.0005 11.8926 14.86 11.6632 14.6098L7.33349 9.88476L3.00376 14.6098C2.77443 14.86 2.46338 15.0005 2.13904 15.0005C1.81471 15.0005 1.50366 14.86 1.27432 14.6098C1.04498 14.3596 0.916138 14.0202 0.916138 13.6664C0.916138 13.3126 1.04498 12.9733 1.27432 12.7231L5.60557 7.99976L1.27432 3.27643C1.04498 3.02624 0.916138 2.68692 0.916138 2.3331C0.916138 1.97928 1.04498 1.63995 1.27432 1.38976C1.50366 1.13958 1.81471 0.999023 2.13904 0.999023C2.46338 0.999023 2.77443 1.13958 3.00376 1.38976L7.33349 6.11476L11.6632 1.38976C11.8926 1.13958 12.2036 0.999024 12.5279 0.999024C12.8523 0.999024 13.1633 1.13958 13.3927 1.38976C13.622 1.63995 13.7508 1.97928 13.7508 2.3331C13.7508 2.68692 13.622 3.02624 13.3927 3.27643Z"
                  fill="#292929"
                />
              </svg>
            </button>
            <main id="modalMain" class="flex flex-col" :class="[!closeBtnIsVisible ? 'mb-3' : '']">
              <slot></slot>
            </main>
          </div>
        </GrowTransition>
      </div>
    </div>
  </ModalBackdrop>
</template>

<script lang="ts" setup>
import { defineProps, onMounted } from 'vue';
import ModalBackdrop from './ModalBackdrop.vue';
import GrowTransition from './GrowTransition.vue';

const props = defineProps({
  closeBtnIsVisible: { type: Boolean },
  closeOnClickOutside: { type: Boolean },
  duration: { type: Number, default: 300 },
  hideFunction: { type: Function, required: true },
});

function clickOutsideFunction() {
  if (props.closeOnClickOutside === false) return;
  props.hideFunction();
}

onMounted(() => {
  const modal = document.querySelector('.modal-wraper > div');
  const sideBar = document.getElementById('leftSideBar');
  if (!modal || !sideBar) return;

  const hasSideBar = window.getComputedStyle(sideBar)?.getPropertyValue('display');

  if (hasSideBar && hasSideBar !== 'none') {
    modal.style.paddingLeft = sideBar.offsetWidth + 'px';
  } else {
    modal.style.paddingLeft = '0.75rem';
  }
});
</script>

<style lang="scss" scoped>
.wFillAvailable {
  max-width: fill-available;
}
.fillAvailable {
  max-height: fill-available;
  @extend .wFillAvailable;
}

.modal {
  background-color: var(--color-bg-primary, white);
}
.close {
  text-shadow: 0 1px 0 #fff;
}
.buttonNext2:not(:disabled) {
  background-color: var(--button-background, var(--color-primary));
  color: var(--button-label-color, var(--color-primary-contrast));

  &:hover {
    background: var(--button-background-hover, var(--color-primary-shade));
    color: var(--button-label-hover-color, var(--color-primary-contrast));
  }
}
</style>
<style lang="scss">
#modalMain .customWidthModal {
  max-width: fill-available;
  max-height: fit-content;
  padding-bottom: 2rem;
}
</style>
